import React from "react";
import styled from "styled-components";

import Button from "common-components/Buttons";
import { media } from "utils/style";

const FallbackUI = () => (
  <Div>
    <H1>We're sorry, but something went wrong while trying to load this page.</H1>
    <Button onClick={() => window.location.reload()}>Reload page</Button>
  </Div>
);

export default FallbackUI;

const Div = styled.div`
  padding: 50px 20px;

  ${media.mobile`
    padding: 35px 16px;
  `}
`;

const H1 = styled.h1`
  margin-bottom: 50px;
  font-size: 32px;
  line-height: 30px;
  max-width: 520px;
`;
